interface MenuComPagina {
  page?: string | null;
}

export const possuiMenuPermitido = (menus: Array<MenuComPagina> | null | undefined, page: string) =>
  !!menus && menus.some((menu) => menu.page === page);
